import { render, staticRenderFns } from "./VideoThumbnail.vue?vue&type=template&id=6f73fdca&scoped=true&"
import script from "./VideoThumbnail.vue?vue&type=script&lang=js&"
export * from "./VideoThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73fdca",
  null
  
)

export default component.exports